import pick from "lodash/pick";

export const prepareCSVExportData = ({
  labels,
  rows,
  rename,
  keys,
  format
}) => {
  const rowKeys = Array.isArray(keys)
    ? keys
    : Array.isArray(rows) && rows[0] && rows[0].values
    ? Object.keys(rows[0].values)
    : [];
  const headers = Array.isArray(rowKeys)
    ? rowKeys.map((key) => {
        const isRenamed = Boolean(rename && rename[key]);
        const namedKey = isRenamed ? rename[key] : key;
        const hasLabel = Boolean(labels && labels[key]);
        const namedLabel = hasLabel ? labels[key] : namedKey;

        return {
          key: namedKey,
          label: namedLabel
        };
      })
    : [];

  const data = Array.isArray(rows)
    ? rows.map(({ values }) => {
        const result = Array.isArray(keys) ? pick(values, keys) : { ...values };
        for (const formatter in format) {
          if (result[formatter] && typeof format[formatter] === "function") {
            result[formatter] = format[formatter](result[formatter]);
          }
        }
        for (const renameKey in rename) {
          if (Object.hasOwnProperty.call(result, renameKey)) {
            const updatedKey = rename[renameKey];
            result[updatedKey] = result[renameKey];
            delete result[renameKey];
          }
        }
        return result;
      })
    : [];

  return { headers, data };
};
